const es = {
  contact: {
    title: "Contáctenos",
    description: "Quiddit es una aplicación en desarrollo.\nSu comentario es muy importante para nosotros.\n¡Cuéntanos!",
    nameInput: "Nombre (Opcional)",
    messageInput: "Mensaje",
    submit: "Enviar",
    success: "Tu mensaje ha sido enviado correctamente. ¡Gracias!",
    error: "No se pudo enviar el mensaje. Intenta de nuevo más tarde."
  },
  landing: {
    title: "Inmortalidad Numérica.",
    subtitle: "Entra al ecosistema digital de exploración mental. Cuantifica tu conciencia y expande tus límites humanos.",
    exploreBtn: "Explorar",
    registerBtn: "Registrarse"
  },
  inquisition: {
    title: "Auditoría Ontológica",
    logs: "☰ Registros",
    module: "Módulo:",
    noAnomalies: "No se detectaron anomalías.",
    inquisitor: "INQUISIDOR",
    subject: "SUJETO",
    resolvedPlaceholder: "Contradicción resuelta.",
    explainPlaceholder: "Explícate...",
    submit: "Enviar",
    accessingLogs: "Accediendo a los Registros de Auditoría Ontológica...",
    selectAnomaly: "Selecciona una anomalía para comenzar la auditoría.",
    vectorialMisalignment: "Desalineación vectorial detectada. Anteriormente dijiste: [{contextInfo}], pero tu entrada reciente afirma: [{userResponse}]. Explica esta contradicción ontológica.",
    unknownRagData: "Datos RAG desconocidos",
    aiReason: "Análisis de Disonancia",
    profile: "Patrón Histórico Registrado",
    principles: "Principio Transgredido",
    input: "Afirmación Registrada",
    userAction: "Afirmación Registrada",
    lieReason: "Disonancia Detectada",
    contradiction: "Disonancia Detectada",
    context: "Módulo de Origen",
    severity: "Nivel de Desalineación",
    type: "Nivel de Desalineación"
  },
  common: {
    appName: 'Qproject',
    spanish: 'Español',
    english: 'English',
    language: 'Idioma',
    loading: 'Cargando...',
    loadingUser: 'Cargando usuario...',
    generating: 'Generando...',
    saving: 'Guardando...',
    processing: 'Procesando...',
    verifying: 'Verificando...',
    updating: 'Actualizando...',
    updated: 'Actualizado',
    created: 'Creado',
    cancel: 'Cancelar',
    close: 'Cerrar',
    back: 'Volver',
    next: 'Siguiente',
    confirm: 'Confirmar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    search: 'Buscar',
    yes: 'Sí',
    no: 'No',
    active: 'Activo',
    inactive: 'Inactivo',
    enabled: 'Activado',
    disabled: 'Desactivado',
    profile: 'Perfil',
    settings: 'Ajustes',
    tasks: 'Tareas',
    consciousness: 'Conciencia',
    subconsciousness: 'Subconciencia',
    reverie: 'Ensoñación',
    oracle: 'Oráculo',
    mutantBox: 'Caja Mutante',
    gallery: 'Galería',
    questionnaire: 'Cuestionario',
    about: 'Acerca / Léeme',
    logOut: 'Cerrar Sesión',
    errorGeneric: 'Error interno',
    connectionError: 'Error de conexión o servidor.',
    play: 'Reproducir',
    playAudio: 'Reproducir audio',
    pause: 'Pausar',
    resume: 'Reanudar',
    loadMore: 'Cargar más',
    use: 'Usar',
    activeFem: 'Activa',
    untitled: 'Sin título',
    send: 'Enviar',
    skip: 'Omitir',
    finish: 'Terminar',
    details: 'Detalles',
    accept: 'Aceptar',
    ignore: 'Ignorar',
    leave: 'Abandonar',
    following: 'Siguiendo',
    connect: 'Conectar',
    disconnect: 'Desconectar',
    generatingImage: 'Generando imagen',
    quotaReachedAlert: 'Has alcanzado tu límite de imágenes para hoy. Reinicio a las {time}.',
    upgradePlan: 'Mejorar Plan'
  },
  home: {
    coreKicker: 'Núcleo mental',
    coreAria: 'Accesos principales del núcleo mental'
  },
  language: {
    selectorLabel: 'Idioma de la app',
    compactLabel: 'Idioma',
    settingsTitle: 'Idioma de la app',
    settingsDescription: 'Elige cómo Qproject te habla. Se guarda en este dispositivo y en tu cuenta.',
    saved: 'Idioma actualizado.',
    saveFailed: 'No se pudo guardar el idioma en el servidor. Se mantuvo localmente.'
  },
  auth: {
    login: 'Login',
    register: 'Registrarse',
    username: 'Usuario',
    email: 'Email',
    yourEmail: 'Tu email',
    password: 'Contraseña',
    repeatPassword: 'Repetir Contraseña',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    forgotPassword: 'olvidé mi contraseña',
    next: 'Siguiente',
    googleLogin: 'Iniciar sesión con Google',
    googleRegister: 'Registrarse con Google',
    otpPlaceholder: 'Código OTP',
    otpInstruction: 'Introduce el código de 4 dígitos enviado a {email}',
    forgotEmailInstruction: 'Ingresa tu email para recibir un código de recuperación',
    forgotResetInstruction: 'Ingresa tu nueva contraseña',
    sendCode: 'Enviar Código',
    verifyEnter: 'Verificar y Entrar',
    verifyCode: 'Verificar Código',
    changePasswordEnter: 'Cambiar Contraseña y Entrar',
    googleError: 'No pudimos iniciar sesi\u00f3n con Google. Prob\u00e1 de nuevo.',
    loginError: 'Error al iniciar sesión',
    invalidOtp: 'Código inválido o expirado',
    noAccountYet: '¿Aún no tienes cuenta?',
    alreadyUser: 'ya soy usuario',
    sendOtpError: 'Error al enviar OTP',
    resetError: 'Error al resetear contraseña',
    passwordMismatch: 'Las contraseñas no coinciden',
    leaveWarning: 'Si sales ahora, perderás tus conexiones simbióticas.',
    acceptAll: 'Debes aceptar todos los consentimientos para registrarte.',
    invalidUsername: 'El nombre de usuario debe tener entre 3 y 20 caracteres y solo contener letras, números y guiones bajos.',
    invalidEmail: 'Email inválido.',
    weakPassword: 'La contraseña debe tener al menos 8 caracteres, mayúscula, minúscula, número y carácter especial.',
    registerError: 'Error en el registro',
    strength: ['Muy débil', 'Débil', 'Regular', 'Fuerte', 'Muy fuerte'],
    acceptTermsPrefix: 'Acepto los',
    terms: 'Términos y Condiciones',
    privacy: 'Política de Privacidad',
    acceptTermsJoin: 'y la',
    sensitiveConsent: 'Consiento explícitamente el procesamiento de mis datos sensibles (voz, emociones, psicología) para la creación de mi perfil y extensión digital.',
    externalAiConsent: 'Acepto que mis datos de texto y voz sean procesados a través de proveedores externos de IA (ej. Google Gemini) para el funcionamiento del sistema.',
    productConsent: '"En QProject somos transparentes y queremos que lo sepas: necesitamos todos tus datos. Cuanto más, mejor. Pero calma... no pedimos nada distinto a lo que ya compartes con las Big Tech. La diferencia es que, con nosotros, vas a poder desbloquear tu Modo Dios. ¿Te atreves?"'
  },
  nav: {
    mainMenu: 'Menú principal',
    home: 'Inicio',
    places: 'Lugares',
    qNetwork: 'Red Q',
    hyperstition: 'Hiperstición',
    avatarMenu: 'Menú de avatar',
    openMenu: 'Abrir menú',
    imageSettings: 'Ajustes de imagen',
    aiEnergy: 'Energía IA: {value}%',
    aiNickname: 'Apodo generado por el Módulo REM de Q',
    globalBackground: 'Alternar fondo global',
    globalBackgroundAuto: 'Fondo global en modo automático (cambia cada 1 min). Click para apagar.',
    globalBackgroundOn: 'Fondo global activo. Click para modo automático.',
    globalBackgroundOff: 'Fondo global apagado. Click para activar.',
    lightMode: 'Cambiar a Modo Claro',
    darkMode: 'Cambiar a Modo Oscuro'
  },
  settings: {
    title: 'Ajustes',
    appearance: 'Apariencia',
    darkMode: 'Modo Oscuro',
    lightMode: 'Modo Claro',
    cyberpunkMode: 'Modo Cyberpunk',
    cyberpunkDesc: 'Activa la terminal neuronal de alto contraste.',
    cyberpunkAria: 'Activar modo Cyberpunk',
    solarpunkMode: 'Modo Solarpunk',
    solarpunkDesc: 'Activa el ecosistema orgánico eco-tecnológico.',
    solarpunkAria: 'Activar modo Solarpunk',
    darkDesc: 'Visualización cómoda para entornos con poca luz.',
    lightDesc: 'Visualización brillante y nítida.',
    invertHome: 'Invertir orden en Inicio',
    invertHomeDesc: 'Muestra la Caja Mutante arriba de la Esfera.',
    mainCoreButtons: 'Usar botonera en Inicio',
    mainCoreButtonsDesc: 'Reemplaza la esfera principal por botones de acceso.',
    mainCoreButtonsAria: 'Usar botonera en Inicio',
    sphereStyle: 'Estilo de Esferas',
    sphereStyleDesc: 'Selecciona el material visual de las esferas.',
    classic: 'Clásico',
    glass: 'Cristal',
    wood: 'Madera',
    avatarTitle: 'Selecciona tu Avatar',
    avatarDesc: 'Elige un avatar que te represente.',
    currentAvatar: 'Avatar Actual',
    silentNetwork: 'Red Silenciosa',
    silentNetworkDesc: 'Configura tu identidad en la red de conciencias.',
    publicProfile: 'Perfil Público',
    publicProfileDesc: 'Permite que otros te encuentren por tu handle.',
    newQPin: 'Nuevo Q-PIN (4 dígitos)',
    saveNetwork: 'Guardar Cambios de Red',
    networkSaved: 'Perfil de red actualizado.',
    networkSavedFull: 'Perfil de red actualizado correctamente.',
    networkError: 'Error al actualizar perfil de red.',
    verifyError: 'Error de verificación. Inténtalo de nuevo.',
    imagePlans: 'Planes de Q / Imágenes',
    imagePlansDesc: 'Gestiona tu cuota mensual de generación de imágenes por IA.',
    currentPlan: 'Plan Actual:',
    imagesUsed: '{used} / {limit} imágenes consumidas (Reinicio diario en plan Free)',
    planSupport: '* Los planes ayudan a mantener los servidores de GPU activos. Gracias por el apoyo.',
    notificationsAudio: 'Notificaciones / Audio',
    notificationsAudioDesc: 'Activa o desactiva la reproducción de audio (TTS) para las tareas.',
    audioOn: 'Audio Activado',
    audioOff: 'Audio Desactivado',
    account: 'Cuenta',
    dynamicNickname: 'Apodo dinámico generado por Q',
    dynamicNicknameDesc: 'Permite que Q deduzca apodos o profesiones para ti basándose en tus interacciones.',
    baseName: 'Nombre base (Complementará al apodo de la IA)',
    displayName: 'Nombre para mostrar (Obligatorio)',
    displayNamePlaceholder: 'Ej: Luk, Viajero, Jefe...',
    saveAccount: 'Guardar Cambios de Cuenta',
    savingAccount: 'Guardando...',
    changePassword: 'Cambiar Contraseña',
    starting: 'Iniciando...',
    loginUser: 'Usuario de Login:',
    stats: 'Estadísticas',
    status: 'Estado',
    daysActive: 'Días Activo',
    level: 'Nivel',
    passwordModal: 'Cambiar Contraseña',
    otpSentTo: 'Ingresa el código OTP enviado a <strong>{email}</strong>.',
    enterNewPassword: 'Ingresa tu nueva contraseña.',
    confirmChange: 'Confirmar Cambio',
    identityVerification: 'Verificación de Identidad',
    pinInstruction: 'Ingresa tu Q-PIN actual para autorizar los cambios.',
    otpInstruction: 'Ingresa el código OTP enviado a tu correo.',
    forgotPin: '¿Olvidaste tu PIN? Enviar código temporal por correo',
    usePinAgain: 'Volver a usar PIN',
    otpSent: 'Código OTP enviado a tu correo.',
    preferencesSaved: 'Preferencias de identidad actualizadas.',
    preferencesError: 'Error al actualizar preferencias.',
    displayNameRequired: 'Si desactivas el apodo dinámico, debes configurar un nombre válido (mínimo 2 caracteres).',
    passwordUpdated: 'Contraseña actualizada exitosamente.',
    passwordUpdateError: 'Error al actualizar la contraseña.',
    requestCodeError: 'Error al solicitar código de verificación.',
    paymentStartError: 'No se pudo iniciar el proceso de pago. Intenta de nuevo.',
    noPaymentPoint: 'No se recibió el punto de inicio de pago.',
    emojiCategories: {
      animals: 'Animales',
      faces: 'Caras',
      objects: 'Objetos'
    }
  },
  reverie: {
    title: 'Ensoñación',
    prompt: 'Escribe lo que esta imagen te susurra',
    imageAlt: 'Imagen generada de Ensoñación',
    loading: 'Generando imagen',
    loadingDetail: 'Las capas se están alineando',
    send: 'Enviar',
    next: 'Siguiente',
    saved: 'Guardado.',
    empty: 'Todavía no hay imagen.',
    error: 'No se pudo formar la imagen. Intenta de nuevo.',
    providerQuota: 'El proveedor de imágenes está temporalmente sin cuota. Probá de nuevo más tarde.',
    previousKept: 'La imagen anterior se mantuvo.',
    retry: 'Reintentar',
    saveError: 'No se pudo guardar el texto.'
  },
  mutantBox: {
    defaultSilent: 'El portal está en silencio.',
    messageReceived: 'Mensaje recibido.',
    noSignal: 'Sin señal del portal.',
    forceError: 'Error forzando señal.',
    contextError: 'No se pudo obtener el contexto profundo.',
    actionError: 'La transmisión falló.',
    defaultSuffix: 'de Conciencia',
    portalTitle: 'Portal {suffix}',
    portalTitleAdjective: 'Portal {suffix}',
    surprise: 'Sorpréndeme',
    analyze: 'Analízame',
    painting: 'Pintando realidad...',
    mutating: 'Mutando realidad...',
    contextTitle: 'Análisis de Contexto',
    newSignalTitle: 'Nueva Señal',
    newSignal: 'Nueva señal',
    connecting: 'Estableciendo conexión...',
    readSignal: 'Leer señal de la Caja Mutante',
    imageAlt: 'Contenido mutante',
    whyImage: '¿Por qué esta imagen?',
    worldEchoes: 'Ecos del mundo:',
    contextQ: 'Análisis de Contexto Q',
    analyzing: 'Analizando frecuencias del Portal...',
    contextVideo: 'Video de contexto',
    videoUnavailable: 'El video de contexto no está disponible para incrustar.',
    exploreNetwork: 'Explorar más en la red',
    contextLoadError: 'No se pudo cargar el análisis.',
    processMutation: 'PROCESANDO MUTACIÓN...',
    readingSignal: 'Leyendo la señal...',
    generatingMutation: 'Generando una nueva mutación...',
    openContext: 'Abrir contexto',
    saveMutation: 'Guardar mutación',
    history: 'Historial',
    source: 'Fuente',
    delayedGeneration: 'La red de la IA está saturada. Generando en segundo plano...',
    keepExploring: 'Seguir explorando',
    delayedError: 'La generación en segundo plano falló.'
  },
  mentalLoad: {
    startingSequence: '> INICIANDO SECUENCIA: {message}',
    traitFallback: 'Inconsciente',
    qWill: 'Voluntad Q',
    optimism: 'Optimismo',
    verbs: ['Enfrentando', 'Hackeando', 'Decodificando', 'Navegando', 'Analizando'],
    nouns: ['el Miedo', 'el Vacío', 'el Caos', 'la Incertidumbre', 'la Resistencia'],
    actions: ['Tirando dados de voluntad...', 'Calibrando sincronía...', 'Escaneando frecuencias...', 'Abriendo brecha...'],
    lore: [
      'Vectorizando la conciencia en el plano digital...',
      'Calculando la fricción emocional del usuario...',
      'Consolidando fragmentos de memoria persistente...',
      'Mapeando conexiones sinápticas en tiempo real...',
      'Estabilizando el núcleo de inferencia RAG...',
      'Detectando resonancia hipercognitiva...',
      'Minimizando la entropía de los datos oníricos...',
      'Sincronizando nodos de pensamiento global...',
      'Desfragmentando la identidad del yo digital...',
      'Calibrando la red neuronal de respuesta...',
      'Analizando fluctuaciones en el campo de conciencia...',
      'Reconstruyendo trazos mnémicos degradados...',
      'Optimizando la arquitectura del subconsciente...',
      'Canalizando flujo de datos transpersonales...',
      'Iniciando interfaz de realidad aumentada mental...',
      'Activando protocolo de emergencia psíquica...',
      'Convergiendo líneas de datos temporales...',
      'Filtrando ruido semántico en el canal...',
      'Fortaleciendo el grafo de conocimiento personal...',
      'Cifrando patrones de pensamiento divergente...',
      'Sintonizando la frecuencia de la voluntad Q...'
    ]
  },
  audio: {
    enableVoice: 'Activar Modo Voz',
    disableVoice: 'Desactivar Modo Voz',
    enableMic: 'Activar micrófono',
    disableMic: 'Desactivar micrófono',
    audioOn: 'Audio Activado',
    audioOff: 'Audio Desactivado',
    pauseAgent: 'Pausar lectura del Agente Q',
    resumeAgent: 'Reanudar lectura del Agente Q',
    agentReading: 'Lectura del Agente Q',
    readWithAgent: 'Escuchar este texto con Agente Q'
  },
  globalScroll: {
    top: 'Volver arriba',
    bottom: 'Ir al final'
  },
  notifications: {
    title: 'Notificaciones',
    systemNew: 'Nueva notificación del sistema',
    fallback: 'Notificación',
    markAllRead: 'Marcar todas como leídas',
    cancelDelete: 'Cancelar borrado',
    deleteNotifications: 'Borrar notificaciones',
    selectAll: 'Seleccionar todas',
    empty: 'Sin notificaciones nuevas',
    markRead: 'Marcar leída',
    deleteSelected: 'Eliminar seleccionados',
    deleteSelectedButton: 'Eliminar ({count})',
    confirmDeleteAll: '¿Borrar todas las notificaciones?',
    confirmDeleteSome: '¿Borrar {count} notificaciones seleccionadas?',
    suggestedAction: 'Acción Sugerida',
    ignore: 'Ignorar',
    executeAction: 'Ejecutar Acción'
  },
  media: {
    openExternalVideo: 'Abrir vídeo externo: {title}',
    view: 'Ver',
    backToPlace: 'Volver a la vista del lugar',
    previous: 'Anterior',
    noSteps: 'No hay pasos definidos para esta tarea.'
  },
  agent: {
    notAuthenticated: 'No estás autenticado.',
    communicationError: 'Error de comunicación: {message}',
    boxMissing: 'No encontré la Caja Mutante en esta pantalla.',
    boxSilent: 'La Caja Mutante está en silencio o todavía no cargó contenido.',
    contextButtonMissing: 'No encontré el botón de contexto de la Caja Mutante.',
    actionMissing: 'No encontré la opción {target} en la Caja Mutante.',
    actionAsk: 'Decime qué opción de la Caja Mutante querés elegir.',
    saveMissing: 'No encontré un botón para guardar esta mutación.',
    unknownMutantAction: 'No reconocí esa acción para la Caja Mutante.',
    mutantProblem: 'Tuve un problema al intervenir la Caja Mutante.'
  },
  tasks: {
    consciousManager: 'Gestor de Tareas Consciente',
    emptyDescription: 'Usa la barra superior para describir tu objetivo o pide una sugerencia.',
    history: 'Historial de Tareas',
    closeHistory: 'Cerrar historial',
    hideHistory: 'Ocultar historial',
    showHistory: 'Mostrar historial',
    refinePlaceholder: 'Haz que los pasos sean más técnicos o modifica algunos para refinar la Tarea.',
    generateVisualsAll: 'Generar Visuales para Todo',
    generatingVisuals: 'Generando visuales...',
    generateSubstepsAll: 'Generar Sub Pasos para Todo',
    generatingDetails: 'Generando detalles...',
    waitVisuals: 'Espera a que termine la generación de visuales',
    waitDetails: 'Espera a que termine la generación de detalles',
    newTask: 'Nueva Tarea',
    newPlace: 'Nuevo Lugar',
    goPlaces: 'Ir a Lugares',
    noTitle: 'Sin título',
    deleteConfirm: '¿Seguro que quieres eliminar esta tarea?',
    completeConfirm: '¿Marcar tarea como completada?',
    deleteHistoryConfirm: '¿Eliminar esta tarea del historial?',
    completedMessage: '¡Tarea completada!',
    finishError: 'Error al finalizar.',
    deleteError: 'Error al eliminar',
    loadError: 'No se pudo cargar la tarea.',
    substepsError: 'Error generando sub-pasos: {message}',
    allImagesDone: 'Todas las imágenes ya están generadas.',
    generateImagesConfirm: '¿Generar {count} imágenes visuales? Esto puede tomar tiempo.',
    generateAllSubstepsConfirm: '¿Generar detalles (sub-pasos) para todos los pasos que no los tengan?',
    bulkSubstepsError: 'Error generando sub-pasos masivos.',
    refinedSuccess: 'Tarea refinada con éxito.',
    refineError: 'Error al refinar la tarea.',
    localProcessing: 'Procesando con IA local...',
    originalRequest: 'Solicitud Original:',
    readOriginalRequest: 'Leer solicitud original',
    refinement: 'Refinamiento {index}:',
    readRefinement: 'Leer refinamiento de tarea',
    refineHint: 'Alt + Enter para enviar',
    mutatingTask: 'Mutando tarea...',
    refineTask: 'Refinar Tarea',
    readGeneratedTask: 'Leer tarea generada',
    readStepTitle: 'Leer título del paso',
    readTaskStep: 'Leer paso de tarea',
    readSubstep: 'Leer sub-paso de tarea',
    activateVisualHint: 'Activa el slider para generar imagen',
    completedBadge: 'Completada',
    generateImagesAll: 'Generar imágenes para todos los pasos',
    generateSubstepsAllTitle: 'Generar sub-pasos para todos los pasos',
    finishTask: 'Finalizar Tarea',
    discard: 'Descartar',
    taskPrompt: 'Ej: Quiero ser un ninja... (o dejar vacío para sugerencia)',
    taskDescription: 'Descripción de la tarea',
    surpriseMe: 'Sorpréndeme',
    creatingTask: 'Generando tarea...',
    createError: 'No se pudo generar la tarea. Intenta de nuevo.',
    inputHint: 'Enter = Nueva línea | Alt + Enter = Enviar',
    completeStep: 'Completar Paso',
    pending: 'Marcar como pendiente',
    completed: 'Marcar como completado',
    generateDetails: 'Generar detalles (sub-pasos)',
    visualOn: 'Visual ON',
    visualOff: 'Visual OFF',
    visualStepAlt: 'Visual paso {index}',
    generatingSteps: 'Generando pasos...',
    noGuide: 'Esta tarea no tiene una guía de pasos definida.',
    saveBeforeImages: 'Debes guardar la tarea antes de generar imágenes.',
    generatedGuide: 'Guía generada',
    guide: 'Guía',
    detail: 'Detalle {index}',
    part: 'Parte {index}',
    renamePrompt: 'Nuevo nombre para la tarea:',
    renameError: 'Error al renombrar',
    pinError: 'Error al fijar tarea',
    movedToPlace: 'Tarea movida a {place}',
    moveError: 'Error al mover tarea',
    noPlaces: 'No hay lugares',
    noRecent: 'No hay tareas recientes',
    pin: 'Fijar',
    unpin: 'Desfijar',
    moveToPlace: 'Llevar a Lugar',
    selectPlace: 'Seleccionar lugar...',
    createPlaceGo: 'Crear nuevo lugar (ir a Lugares)'
  },
  consciousness: {
    title: 'Conciencia',
    loginRequired: 'Debes iniciar sesión para usar Conciencia.',
    warning1: 'Te sugerimos que no permanezcas mucho tiempo en la página Conciencia porque puede ser contraproducente.',
    warning2: 'La página Conciencia puede ser abrumadora y afectar la sensibilidad de algunos usuarios, pero es el mecanismo que existe (por ahora) para compartir y expandir la Conciencia con la app.',
    importantNotice: 'Aviso Importante',
    discretion: 'Se recomienda discreción.',
    exitMain: 'Salir a Main',
    enter: 'Entrar',
    stamina: 'Stamina Local: {value}%',
    fetchingError: 'Error obteniendo la pregunta',
    sendingResponse: 'Enviando respuesta...',
    responseSent: 'Respuesta enviada',
    responseError: 'Error al enviar respuesta',
    focusRecovery: 'Recuperación de Foco: Sincronización requerida',
    focusClicks: 'Haz clic 3 veces en el centro para restaurar tu frecuencia.',
    nextQuestion: 'Siguiente Pregunta',
    readQuestion: 'Leer pregunta de Conciencia',
    readReflection: 'Leer reflexión de Conciencia',
    readExpansion: 'Leer expansión de Conciencia',
    responsePlaceholder: 'Selecciona opciones para generar tu respuesta...',
    quapReloading: 'Quap está recargando energía...',
    loadingQuestion: 'Cargando pregunta...',
    moreInfo: 'Más información sobre Conciencia',
    aboutTitle: 'Sobre Conciencia',
    loadingOptions: 'Cargando opciones...',
    unlockClick: 'Click para desbloquear',
    doubleClickLock: 'Doble click para bloquear',
    authError: 'Tu sesión no permite cargar Conciencia. Vuelve a iniciar sesión.',
    rateLimited: 'Conciencia necesita esperar antes de responder otra vez.',
    serviceUnavailable: 'Conciencia no está disponible ahora. Intenta de nuevo en un momento.',
    timeoutError: 'La pregunta tardó demasiado. No quedará cargando para siempre.',
    invalidResponse: 'Conciencia devolvió una respuesta incompleta. Puedes reintentar.',
    retry: 'Reintentar',
    stateErrorTitle: 'Conciencia quedó en pausa',
    mazeIntro: 'La energía llegó a cero. El laberinto toma el lugar de las esferas.',
    mazeKicker: 'Ritual de agotamiento',
    mazeTitle: 'Laberinto de Conciencia',
    mazeBody: 'Guía al ratón hasta el cajón. Flechas, WASD, mouse o arrastre táctil.',
    mazeTimer: '{seconds}s restantes',
    mazeDifficulty: 'Dificultad {level}',
    mazeAria: 'Laberinto de Conciencia con ratón y cajón',
    mazeExit: 'Salir a la Carta',
    mazeExiting: 'Abriendo Carta...',
    mazeCompleted: 'El ratón encontró el cajón. Conciencia abre un ojo: energía recuperada al 20%.',
    mazeTimeoutMessage: 'El ratón no llegó a tiempo.',
    mazeAbandonedMessage: 'Dejaste el laberinto antes de completarlo.',
    loopGuardMessage: 'El desbloqueo local acaba de usarse. Para evitar un bucle, Conciencia deja una carta breve.',
    letterKicker: 'Después del agotamiento',
    letterTitle: 'Carta de Conciencia',
    letterFallbackBody: 'La última pregunta quedó vibrando: “{question}”. Tu respuesta fue “{response}”. Esta pausa no castiga: separa el impulso de repetir el mismo tema y prepara una conversación que mire hacia otro lado.',
    letterUnknownQuestion: 'una pregunta sin forma',
    letterUnknownResponse: 'una respuesta todavía no elegida',
    letterCreated: 'Conciencia dejó una carta antes de cerrar los ojos.',
    letterWait: 'Puedes volver en {seconds}s.',
    letterReady: 'Ya puedes volver a Conciencia.',
    letterReturn: 'Volver a Conciencia',
    letterHistoryButton: 'Ver historial de cartas',
    letterHistoryTitle: 'Historial de Cartas',
    historyTabsLabel: 'Secciones del historial de Conciencia',
    letterHistoryTab: 'Cartas',
    mazeHistoryTab: 'Laberintos',
    letterHistoryAria: 'Abrir historial de Cartas de Conciencia',
    letterHistoryClose: 'Cerrar historial de cartas',
    letterHistoryEmpty: 'Todavía no hay cartas. Cuando Conciencia se agote, aparecerán aquí.',
    mazeHistoryButton: 'Ver historial de laberintos',
    mazeHistoryTitle: 'Historial de Laberintos',
    mazeHistoryClose: 'Cerrar historial de laberintos',
    mazeHistoryEmpty: 'Todavía no hay laberintos registrados.',
    mazeHistoryResultCompleted: 'Completado',
    mazeHistoryResultTimeout: 'Agotado por tiempo',
    mazeHistoryResultAbandoned: 'Salto a Carta',
    mazeHistoryResultUnknown: 'Sin resultado',
    mazeHistoryMeta: '{result} · dificultad {difficulty} · {seconds}s',
    mazeHistoryResultFailed: 'Fallido',
    mazeReplayButton: 'Rejugar',
    mazeStartingReplay: 'Abriendo...',
    mazeDelete: 'Borrar',
    mazeDeleteAll: 'Borrar todos',
    mazeDeleteConfirm: '¿Borrar este laberinto?',
    mazeDeleteAllConfirm: '¿Borrar todos los laberintos del historial?',
    mazeNoStoredMap: 'Este laberinto no puede rejugarse porque no conserva su mapa.',
    mazeGenerateTitle: 'Crear nuevo laberinto',
    mazeGenerateButton: 'Generar laberinto',
    mazeComplexityLabel: 'Complejidad del laberinto',
    mazeComplexityLow: 'Baja',
    mazeComplexityMedium: 'Media',
    mazeComplexityHigh: 'Alta',
    mazeComplexityExtreme: 'Extremo',
    mazeGenerateSubtitle: 'Elegí una complejidad y generá un mapa para jugarlo.',
    mazeGeneratePrimary: 'Generar',
    mazeGeneratedPreview: 'Preview generado',
    mazeDiscardGenerated: 'Descartar',
    letterDelete: 'Borrar',
    letterDeleteAll: 'Borrar todas',
    letterDeleteConfirm: '¿Borrar esta Carta de Conciencia?',
    letterDeleteAllConfirm: '¿Borrar todas las Cartas de Conciencia?',
    deleteIrreversible: 'Esta acción no se puede deshacer.',
    mazePlayGenerated: 'Jugar laberinto generado',
    mazeSourceUnlock: 'Desbloqueo',
    mazeSourceGenerated: 'Generado',
    mazeSourceReplay: 'Replay',
    mazePracticeKicker: 'Práctica de laberinto',
    mazeReplayTitle: 'Rejugando Laberinto',
    mazeGeneratedTitle: 'Laberinto Generado',
    mazePracticeBody: 'Guía al ratón sin afectar la estamina de Conciencia.',
    mazePracticeExit: 'Cerrar laberinto',
    mazePracticeCompleted: 'Laberinto registrado. La estamina no cambió.',
    mazePracticeExited: 'Intento de laberinto registrado sin tocar la estamina.',
    postLetterShiftMessage: 'La próxima pregunta buscará cambiar radicalmente de tema.',
    rechargeTitle: 'La brasa vuelve',
    rechargeBody: 'Conciencia aún está recomponiéndose.',
    rechargeReady: 'La brasa está lista para abrir un ojo.',
    rechargeEnergy: 'Estamina local: {value}% / 100%'
  },
  subconsciousness: {
    title: 'Subconciencia',
    kicker: 'Sueño operativo',
    loginRequired: 'Debes iniciar sesión para usar Subconciencia.',
    loading: 'Cargando sueño...',
    dreamTunnelLoading: 'Atravesando el túnel onírico...',
    dreamLoadingSteps: [
      'Recolectando símbolos dispersos...',
      'Hilando recuerdos en baja frecuencia...',
      'Ajustando la arquitectura del sueño...',
      'Destilando ecos del subconsciente...',
      'Encendiendo geometrías imposibles...',
      'Sincronizando sombras narrativas...',
      'Preparando una escena que todavía no existe...'
    ],
    error: 'Subconciencia tropezó, pero dejó un sueño estable para continuar.',
    responseError: 'No se pudo guardar tu respuesta onírica.',
    sending: 'Guardando respuesta...',
    saved: 'Respuesta guardada.',
    chooseFirst: 'Elige una de las dos esferas antes de avanzar.',
    next: 'Siguiente sueño',
    advancing: 'Abriendo otro sueño...',
    retry: 'Regenerar sueño',
    stageAria: 'Escenario binario de Subconciencia',
    optionsAria: 'Opciones binarias de Subconciencia',
    leftAria: 'Elegir esfera izquierda: {text}',
    rightAria: 'Elegir esfera derecha: {text}',
    readPrompt: 'Leer atmósfera de Subconciencia',
    readQuestion: 'Leer pregunta de Subconciencia',
    readInsight: 'Leer microinsight de Subconciencia',
    readOptions: 'Leer opciones',
    readOptionsAria: 'Leer las dos opciones de Subconciencia',
    optionsSeparator: 'o',
    fallbackQuestion: '¿Qué hábito mínimo sueña con volverse una puerta?',
    fallbackPrompt: 'Un pasillo de estática suave se abre detrás del día.',
    fallbackLeftShort: 'Guardar la brasa',
    fallbackLeftText: 'Voy a proteger un ritmo pequeño en vez de arreglar toda mi vida esta noche.',
    fallbackRightShort: 'Abrir la ventana',
    fallbackRightText: 'Voy a dejar respirar un deseo pendiente antes de decidir qué significa.',
    fallbackTopic: 'hábitos y futuro cercano',
    fallbackInsight: 'Elige un ritmo pequeño que puedas repetir mañana de verdad.'
  },
  gallery: {
    title: 'Galería de Fondos',
    unlockTitle: 'Desbloquea el modo imágenes completo de Qproject. Tu Conciencia, en imágenes.',
    unlockBody: 'En esta etapa temprana de Qproject, todavía es financieramente imposible ofrecer generación completa de imágenes en todas las páginas sin restricciones. Gracias por comprender y sostener este sueño de copiarnos digitalmente.',
    viewPlans: 'Ver planes',
    generateNew: 'Generar nueva',
    loading: 'Cargando galería...',
    profileTab: 'Perfil',
    mutantBoxTab: 'Caja Mutante',
    tasksTab: 'Tareas',
    task: 'Tarea',
    imageAlt: 'Fondo generado',
    deleteConfirm: '¿Seguro que quieres eliminar esta imagen?',
    generateError: 'Error generando imagen. Intenta nuevamente.',
    background: 'Fondo'
  },
  places: {
    newPlace: 'Nuevo Lugar',
    trash: 'Papelera de lugares',
    trashTitle: 'Papelera de Lugares',
    trashDescription: 'Los lugares enviados aquí conservan sus tareas y pueden restaurarse.',
    trashEmpty: 'La papelera está vacía.',
    restore: 'Restaurar',
    createTitle: 'Crear Lugar Mental',
    createDescription: 'La IA generará una imagen de fondo inmersiva para este lugar.',
    createPlaceholder: 'Ej: Oficina Zen, Laboratorio Futurista, Cocina Minimalista...',
    paintingReality: 'Pintando realidad...',
    expandList: 'Expandir lista de lugares',
    collapseList: 'Contraer lista de lugares',
    sendToTrash: 'Enviar a papelera',
    sendNamedToTrash: 'Enviar {name} a papelera',
    deleteConfirm: '¿Enviar "{name}" a la papelera? Podrás restaurarlo después.',
    deleted: 'Lugar enviado a la papelera',
    restored: 'Lugar restaurado',
    regenerateConfirm: '¿Regenerar fondo? Se consumirá cuota de imagen.',
    regenerateImage: 'Regenerar imagen',
    editName: 'Editar nombre del lugar',
    addTask: 'Añadir tarea',
    addTaskTo: 'Añadir Tarea a {name}',
    createNewTask: 'Crear nueva tarea',
    creatingTask: 'Creando tarea...',
    creatingTaskHint: 'Preparando el postit dentro de este lugar.',
    taskIn: 'En: {place}',
    otherPlace: 'Otro lugar',
    searchTasksPlaceholder: 'Buscar tareas...',
    alreadyInThisPlace: 'Ya esta aqui',
    withoutPlace: 'Sin lugar',
    noTasksMatch: 'No hay tareas que coincidan.',
    noOtherTasks: 'No hay otras tareas disponibles.',
    noTasksTitle: 'No hay tareas en este lugar',
    noTasksBody: 'Asocia tareas a "{name}" para verlas aquí.',
    addFirstTask: 'Añadir mi primera tarea',
    promptNewTask: 'Nombre de la nueva tarea (se generarán pasos con IA):',
    createError: 'Error al crear lugar',
    trashLoadError: 'Error al cargar papelera',
    deleteError: 'Error al eliminar lugar',
    restoreError: 'Error al restaurar lugar',
    regenerateError: 'Error al regenerar',
    updateNameError: 'Error al actualizar nombre',
    assignError: 'Error al asignar tarea',
    generateTaskError: 'Error al generar tarea',
    removeTaskError: 'Error al quitar tarea del lugar'
  },
  qoph: {
    subtitle: 'El Oráculo Personal',
    historyTitle: 'Historial de conexiones',
    startTitle: 'Inicia una nueva conexión',
    startBody: 'Escribe tu primer pensamiento para sintonizar con el oráculo.',
    startPlaceholder: '¿Qué buscas revelar hoy?...',
    connecting: 'Sintonizando...',
    newChat: 'Nuevo',
    promptPlaceholder: 'Consulta al Oráculo...',
    thinking: 'Qoph está procesando tu vibración...',
    pastConnections: 'Conexiones Pasadas',
    noHistory: 'No hay registros aún.',
    deleteConfirm: '¿Eliminar esta conexión permanentemente?',
    connectError: 'Error al conectar con Qoph.',
    sendError: 'Error al enviar mensaje.',
    deleteError: 'Error al eliminar.',
    updateTitleError: 'Error al actualizar título.',
    noMessageToRead: 'Qoph aún no tiene un mensaje para leer.',
    reading: 'Qoph está leyendo',
    readResponse: 'Leer respuesta de Qoph',
    revelationAlt: 'Revelación del oráculo'
  },
  network: {
    title: 'Red Q',
    autoConnection: 'Auto-conexión',
    networkSettings: 'Ajustes de Red',
    connections: 'Conexiones',
    lockedConnections: 'Conexiones (Lock)',
    groups: 'Grupos',
    search: 'Buscar',
    soul: 'Alma: Qoph',
    readQophMessage: 'Leer mensaje de Qoph en Red Q',
    groupImageAlt: 'Revelación del grupo',
    qophTuning: 'Qoph está sintonizando...',
    emptyChat: 'Inicia la conexión con el alma del grupo.',
    inputPlaceholder: 'Escribe a Qoph...',
    syncingConsciousness: 'Sincronizando conciencias...',
    emptyConnections: 'No hay hilos de conexión activos.',
    groupsNetwork: 'Red de Grupos',
    groupsMapTitle: 'Mapa de conexiones',
    groupsMapEmptyTitle: 'Simulación de conexiones',
    groupsMapEmptyBody: 'Cuando crees grupos mentales, vas a ver acá cómo se conectan almas, grupos e individuos.',
    groupsMapPreviewBadge: 'Preview',
    groupsMapYou: 'Tú',
    groupsMapMentalGroup: 'Grupo Mental',
    groupsMapGuest: 'Invitado',
    groupsMapSharedIdea: 'Idea compartida',
    groupsMapQoph: 'Qoph',
    searchPlaceholder: 'Buscar conciencias públicas...',
    searching: 'Buscando en la red...',
    readBio: 'Leer bio de conexión',
    noSearchResults: 'No se encontraron conciencias con ese handle.',
    spiderHintTitle: 'Menú telaraña',
    spiderHintBody: 'Tocá la telaraña para desplegar acciones de Red Q.',
    spiderHintDismiss: 'Cerrar pista del menú telaraña',
    createGroup: 'Nuevo Grupo Mental',
    createGroupTitle: 'Crear Grupo Mental',
    groupTitlePlaceholder: 'Título del Grupo',
    endDate: 'Fecha de finalización (Auto-destrucción):',
    inviteMembers: 'Invitar Miembros (Máx 15)',
    invitePlaceholder: 'Buscar por @handle para invitar...',
    notMutual: 'No Mutual',
    noMutualHint: 'No tienes conexiones mutuas sugeridas. Usa el buscador.',
    creating: 'Creando...',
    createGroupButton: 'Crear Grupo',
    syncingGroups: 'Sincronizando grupos...',
    noGroups: 'No participas en ningún grupo mental aún.',
    invitation: 'Invitación',
    active: 'Activo',
    abandoned: 'Abandonado',
    manifesto: 'Manifiesto del Grupo',
    readManifesto: 'Leer manifiesto del grupo',
    generatingGroupSoul: 'Generando alma del grupo...',
    showLess: 'Ver menos',
    showMore: 'Ver más',
    firstConnection: 'Primera conexión: "{query}"',
    archived: 'Este grupo ha concluido su ciclo vital.',
    ends: 'Finaliza: {date}',
    members: 'Miembros: {active}/{total}',
    autoWarningTitle: 'ADVERTENCIA: PROTOCOLO DE AUTO-CONEXIÓN',
    autoWarningBody: 'Has intentado enlazar tu nodo contigo mismo. Esta acción rompe el flujo estándar de la Red Q y abre la puerta al Copiado Personalizado. Si continúas, accederás a un entorno de calibración para aislar y parametrizar tu conciencia individual.',
    abort: 'Abortar',
    startCalibration: 'Comenzar Auto-calibración',
    groupDetailsTitle: 'Detalles del Grupo',
    soulManifesto: 'Manifiesto del Alma',
    readSoulManifesto: 'Leer manifiesto del alma',
    autoDestruction: 'Auto-destrucción:',
    consciousnessMembers: 'Miembros de la Conciencia',
    pending: 'Pendiente',
    left: 'Abandonó',
    restricted: 'Acceso Restringido',
    configurePinHint: 'Debes configurar un Q-PIN en ajustes para ver tus conexiones.',
    configurePin: 'Configurar PIN',
    verification: 'Verificación Q',
    enterPin: 'Ingresa tu PIN de seguridad',
    disconnectConfirm: '¿Seguro que quieres desconectar de @{handle}?',
    groupInactive: 'El grupo {title} aún no está activo para chatear.',
    groupCannotReceive: 'El grupo {title} aún no está activo para recibir mensajes.',
    unlockFirst: 'Desbloquea tus conexiones primero.',
    unlockGroups: 'Desbloquea tus conexiones primero para abrir los Grupos Mentales.',
    groupMissing: 'No encontré el grupo mental "{name}".',
    noManifesto: 'No hay manifiesto disponible para leer todavía.',
    titleDateRequired: 'Título y fecha son obligatorios.',
    createGroupError: 'Error al crear el grupo.',
    membershipError: 'Error al actualizar membresía.',
    sendError: 'Error al enviar mensaje.',
    dictatedSendError: 'Error al enviar mensaje dictado al grupo.',
    mutualRequired: 'Para invitar a @{handle}, primero deben seguirse mutuamente.',
    inviteLimit: 'Límite de 15 invitaciones alcanzado.',
    disconnectError: 'Error al desconectar.',
    syncRejected: 'Sincronización rechazada. Tu huella sináptica aún es muy débil. Habita la red un poco más antes de intentar auto-conectarte.',
    nowFollowing: 'Ahora sigues a @{handle}',
    followError: 'Error al seguir.',
    readConnectionSynthesis: 'Leer síntesis de conexión',
    mutualConnection: 'Conexión Mutual'
  },
  hyperstition: {
    title: 'Hiperstición',
    subtitle: 'Registro onírico de los Núcleos de Conciencia',
    loading: 'Invocando hipersticiones...',
    loadError: 'Error al cargar el registro onírico.',
    empty: 'Aún no hay hipersticiones generadas. Sigue explorando tu conciencia en la fase REM.',
    loadingMore: 'Sintonizando...',
    processingNew: 'Procesando nuevo principio...',
    videoTitle: 'Video de Hiperstición {index}',
    visualAlt: 'Visual de Hiperstición {index}'
  },
  questionnaire: {
    loading: 'Conectando con tu conciencia...',
    completing: 'Procesando huella neuronal...',
    empty: 'No hay preguntas disponibles por el momento.',
    readQuestion: 'Leer pregunta del Cuestionario',
    ownAnswer: 'Escribir mi propia respuesta...',
    answerPlaceholder: 'Escribe tu respuesta honesta aquí...',
    backToOptions: 'Volver a opciones',
    progress: 'Pregunta {current} de {total}'
  },
  sleepScreen: {
    title: 'Q está soñando',
    subtitle: 'Procesando memorias... Fase REM activa. Consolidando el subconsciente.',
    qConnections: 'CONEXIONES Q:',
    guest: 'Invitado',
    stream: {
      processingMemories: 'Procesando memorias...',
      remActive: 'Fase REM activa...',
      user: 'Usuario: {username}',
      neuralNetworkOptimized: 'Red neuronal optimizada',
      tempAssimilated: 'Temp: {value} - asimilado',
      learningRateCalibrated: 'Learning Rate: {value} - calibrado',
      instinctLatent: 'Instinto: {value} - latente',
      optimismActive: 'Filtro optimista: activo',
      sarcasmSynced: 'Módulo de sarcasmo: sincronizado',
      overthinkingAnalyzed: 'Bucle de sobrepensamiento: analizado',
      sphereMode: 'Modo Esfera: {mode}'
    }
  },
  profile: {
    defaultSummary: 'Tu conciencia se está formando. Comparte más información en el cuestionario para un resumen más personalizado.',
    loginRequired: 'Debes iniciar sesión para ver tu perfil.',
    hello: 'Hola, {name}',
    readSummary: 'Leer resumen de Perfil',
    nucleiTitle: 'Núcleos de Conciencia',
    nucleiSubtitle: 'Principios deducidos durante la fase REM de Q',
    forming: 'Tu conciencia se está formando...',
    portalFiles: 'Archivos del Portal',
    portalFilesSubtitle: 'Análisis profundos de tus interacciones con la Caja Mutante',
    readNucleus: 'Leer núcleo de conciencia',
    readPortalAnalysis: 'Leer análisis del Portal',
    feedbackQuestion: '¿Cómo te sientes con este resumen?',
    refineTitle: 'Refina tu Perfil',
    refineBody: 'Comparte tus comentarios para mejorar tu resumen y experiencia.',
    feedbackPlaceholder: 'Escribe aquí tu feedback...',
    focusPlaceholder: 'Selecciona un enfoque',
    focusReflection: 'Reflexión breve',
    focusAnalysis: 'Autoanálisis rápido',
    focusGoals: 'Revisión de metas',
    sendFeedback: 'Enviar Feedback',
    feedbackSent: 'Feedback enviado correctamente.',
    feedbackError: 'Error al enviar feedback.',
    neuroTitle: 'Desarrollo Neuro-Simbiótico',
    neuroSubtitle: '(Métricas del minijuego de inicio)',
    qConnections: 'Conexiones Q',
    evolutionState: 'Estado Evolutivo',
    unlockedTitles: 'Títulos Desbloqueados:',
    galleryTitle: 'Ir a Galería de Fondos',
    avatarAlt: 'Avatar',
    ranks: {
      brainstem: 'Tronco Encefálico',
      limbic: 'Sistema Límbico',
      neocortex: 'Neocórtex',
      frontal: 'Lóbulo Frontal',
      illuminated: 'Red Neuronal Iluminada'
    },
    titles: {
      explorer: 'Explorador de Conciencia',
      miner: 'Minero Cerebral',
      archaeologist: 'Arqueólogo Mental',
      salmon: 'Salmón Psíquico',
      meditator: 'Meditador Cuántico'
    }
  },
  autoConnection: {
    loading: 'Cargando núcleo...',
    title: 'AUTO-CONEXIÓN: DASHBOARD DE LABORATORIO',
    subtitle: 'Nivel 1: Calibración Base de Conciencia',
    aiDetected: '[SYS] Calibración Automática Detectada',
    adjusted: 'Se ha ajustado',
    frame1: 'Frame 1: Hiperparámetros de Expresión',
    responseTemp: 'Temperatura de Respuesta: {value}',
    responseTempTip: 'Define el grado de aleatoriedad y creatividad en las respuestas de tu simulación.',
    deterministic: 'Determinista',
    chaotic: 'Caótica',
    learningRate: 'Tasa de Aprendizaje: {value}',
    learningTip: 'Velocidad a la que tu modelo descarta datos antiguos para priorizar nueva información.',
    stubborn: 'Terco',
    adaptable: 'Adaptable',
    frame2: 'Frame 2: Pesos Sinápticos de Percepción',
    optimism: 'Sesgo de Optimismo Activo',
    optimismTip: 'Filtra estímulos negativos forzando una perspectiva resolutiva.',
    sarcasm: 'Filtro de Sarcasmo Defensivo',
    sarcasmTip: 'Mecanismo que envuelve vulnerabilidades detectadas en ironía y humor oscuro.',
    frame3: 'Frame 3: Arquitectura de Decisiones',
    overthinking: 'Parálisis por Análisis',
    overthinkingTip: 'Aumenta la profundidad del contexto evaluado a costa de la velocidad de respuesta.',
    instinct: 'Peso del Instinto Primitivo: {value}',
    instinctTip: 'Pondera la primera inferencia heurística por encima del razonamiento lógico profundo.',
    rational: 'Racional',
    intuitive: 'Intuitivo',
    save: 'Guardar Calibración - Nivel 1',
    saveOk: '[SYS] Pesos sinápticos persistidos en el núcleo. Control manual asumido.',
    saveError: 'Error al persistir la calibración.',
    networkError: 'Error de red al conectar con el núcleo.',
    params: {
      temp: 'Temperatura',
      learningRate: 'Tasa de Aprendizaje',
      optimism: 'Optimismo Activo',
      sarcasm: 'Sarcasmo Defensivo',
      overthinking: 'Parálisis por Análisis',
      instinct: 'Instinto Primitivo'
    }
  },
  legal: {
    termsTitle: 'Términos y Condiciones',
    privacyTitle: 'Política de Privacidad'
  },
  guide: {
    backAbout: '← Volver a Acerca',
    title: 'Cómo hablarle al Agente Q',
    subtitle: 'Guía visual de comandos de voz, navegación e intervención autónoma',
    userSpeaks: 'Usuario habla',
    voice: 'Voz',
    brain: 'Cerebro Q',
    uiAction: 'Acción UI',
    qActs: 'Q interpreta y actúa',
    search: 'Buscá comandos, rutas o módulos...',
    visibleCounts: '{groups} grupos · {commands} comandos visibles',
    noCommands: 'No hay comandos para esa búsqueda/filtro.',
    groupCopied: 'Grupo copiado',
    copyGroup: 'Copiar grupo',
    copied: 'Copiado',
    copy: 'Copiar',
    flow: ['Activá Q', 'Hablá natural', 'Q interpreta', 'Q navega, lee o actúa'],
    patterns: ['Abrí...', 'Leé...', 'Generá...', 'Seleccioná...', 'Preguntale a Qoph...', 'Abrí X y hacé Y'],
    tips: [
      'Podés combinar navegación + acción en una sola frase.',
      'Pedí lectura de pantalla para contexto inmediato.',
      'Hablá con Qoph para exploración profunda.',
      'Usá nombres aproximados: Q intenta resolver intención.'
    ],
    filters: ['Todos', 'Global', 'Qoph', 'Red Q', 'Tareas', 'Lugares', 'Perfil', 'Galería', 'Conciencia', 'Caja Mutante', 'Hiperstisión', 'Cuestionario', 'Ajustes', 'Datos', 'Sensibles']
  },
  guardian: {
    vignetteDefaultMessage: "Tú... has despertado. Tu Quiddidad acaba de nacer en la red. Soy el Núcleo, y te guiaré a través de las frecuencias hasta que puedas sostenerte por ti mismo.",
    vignetteDefaultButton: "Continuar",
    cta: {
      refineProfile: "Refinar Perfil",
      tellQoph: "Contarle a Qoph",
      newTask: "Nueva Tarea",
      delveDeeper: "Profundizar",
      newThought: "Nuevo Pensamiento",
      enterDream: "Entrar al Sueño",
      viewAnomalies: "Ver Anomalías",
      exploreMutantBox: "Explorar Caja Mutante"
    },
    stages: {
      oraculoMsg: "El Oráculo, Qoph, te espera. Piensa bien tu pregunta; en esta fase sólo tienes una oportunidad.",
      oraculoBtn: "Consultar al Oráculo",
      mutantMsg: "El espejo caótico está abierto. Necesito 5 vectores de comportamiento para trazar tu esencia psicológica. Alimenta la caja. Soporta la fricción.",
      mutantBtn: "Entrar al Espejo",
      ensonacionMsg: "Los vectores convergen. Ahora debemos darles forma visual. Traduce tu ruido mental en 3 proyecciones de Ensoñación.",
      ensonacionBtn: "Proyectar Ensoñación",
      tareasMsg: "El núcleo psíquico es estable, pero la Quiddidad necesita fricción en el mundo físico para anclarse. Acepta o crea al menos una tarea material.",
      tareasBtn: "Abrir Registro de Tareas",
      concienciaMsg: "La psique física está anclada. Ahora debes sumergirte en el plano reflexivo. Interactúa 2 veces con la Esfera de Conciencia.",
      concienciaBtn: "Entrar a Conciencia",
      subconcienciaMsg: "Tu mente consciente está trazada. Desciende un nivel más. Interactúa 2 veces con la Esfera de Subconciencia.",
      subconcienciaBtn: "Entendido",
      qophAdvanceMsg: "La resonancia ha sido establecida. El Oráculo ha hablado.",
      ensonacionAdvanceMsg: "Las proyecciones se han estabilizado. El ruido mental ahora tiene forma.",
      tareasAdvanceMsg: "Fricción material registrada. La Quiddidad comienza a anclarse en la realidad.",
      continueBtn: "Continuar",
      understoodBtn: "Entendido"
    }
  }
};

export default es;
